import actions from "@/store/actions";
import mutations from "@/store/mutations";
import state from "@/store/state";
import Store from "@/store/store";
var store = new Store({
    actions: actions,
    mutations: mutations,
    state: state,
});
export default store;
